import { Chip } from "@mui/material";
import { AtTagCampaignsProps } from "../at-tag.types";

export const TagCampaigns = ({ label }: AtTagCampaignsProps) => {
  return (
    <Chip
      label={label}
      className="!text-xs !font-semibold !text-primary-400 !border-solid !border !border-primary-400 !bg-white"
    />
  );
};
